// Signal kind and Raised are hidden below md, so the xs grid has fewer columns.
// The trailing column is the always-visible Actions (⋮) cell.
export const ROW_GRID = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '24px 34px minmax(0, 1fr) 44px 40px',
    md: '28px 38px minmax(0, 1fr) 260px 76px 150px 44px',
  },
  gap: {xs: 1, md: 1.75},
  px: {xs: 1.5, md: 2.5},
} as const;

export const KIND_CELL = {display: {xs: 'none', md: 'flex'}} as const;

export const RAISED_CELL = {display: {xs: 'none', md: 'block'}} as const;

export const ACTIONS_CELL = {
  display: 'flex',
  justifyContent: 'center',
} as const;
